<template>
  <div class="">
    <b-modal
      ref="modal-lotList"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Üretim Fişi"
      size="lg"
      hide-footer
    >
      <div id="invoice-page">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>
        <div id="printMe2">
          <vx-card id="invoice-container" style="padding: 25px">
            <!-- INVOICE METADATA -->
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td class="p-2">
                  <h6>Üretim Reçetesi</h6>
                </td>
                <td style="padding: 10px; text-align: right">
                  <h6>Yayın Tarihi:</h6>
                  <p>{{ getNow() }}</p>
                </td>
              </tr>
            </table>

            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td
                  style="
                      padding-top: 25px;
                      text-align: left;
                      padding-bottom: 25px;
                      border-top: solid;
                    "
                >
                  <tr>
                    <td>Ürün Adı:</td>
                    <td>{{ STOCKNAME }}</td>
                  </tr>
                  <tr>
                    <td>Ürün Kod:</td>
                    <td>{{ STOCKNO }}</td>
                  </tr>
                  <tr>
                    <td>Üretim Tarihi:</td>
                    <td>{{ getNow() }}</td>
                  </tr>
                </td>
              </tr>
            </table>

            <br />
            <br />
            <table
              style="border-top: 1px solid grey; width: 100%"
              class="border-collapse"
            >
              <tr>
                <td>
                  <table style="width: 100% !important; text-align: center">
                    <tr>
                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Stok Kodu
                      </th>
                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Hammadde
                      </th>
                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Formül(gr)
                      </th>
                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Marka/Grade
                      </th>
                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Lot No
                      </th>

                      <th
                        style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            border-right: 1px solid grey;
                            padding: 3px;
                          "
                      >
                        Formül(kg)
                      </th>
                    </tr>

                    <tr :key="indextr" v-for="(tr, indextr) in receteListesi" style="
                            text-align: center;
                            border-bottom: 1px solid grey;
                            padding: 3px;
                          ">
                      <td style="padding: 8px; border-left: 1px solid grey;" >
                        {{ tr.STOCKNO }}
                      </td>
                      <td style="padding: 8px; border-left: 1px solid grey;">
                        {{ tr.STOCKNAME }}
                      </td>

                      <td style="padding: 8px; text-align: right; border-left: 1px solid grey;">
                        {{
                          (parseFloat(tr.lotMiktar) * 1000).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        }}
                        gr
                      </td>
                      <td style="padding: 8px; border-left: 1px solid grey;" ></td>
                      <td style="padding: 8px; border-left: 1px solid grey;">{{ tr.lotKodu }}</td>
                      <td style="padding: 8px; text-align: right; border-left: 1px solid grey; border-right: 1px solid grey;">
                        {{
                          parseFloat(tr.lotMiktar).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        }}

                        kg
                      </td>
                    </tr>

                    <tr>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                            font-weight: bold;
                            border-top: 1px solid grey;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 8px;
                            text-align: right;

                          "
                      >
                        Toplam:
                      </td>
                      <td
                        style="
                            font-weight: bold;
                            border-top: 1px solid grey;
                            text-align: left;
                            border-bottom: 1px solid grey;
                            border-right: 1px solid grey;
                            padding: 8px;
                          "
                      >
                      
                        {{
                          (totalQuantity * 1000).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        }}gr
                      </td>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                            font-weight: bold;
                            border-top: 1px solid grey;
                            border-bottom: 1px solid grey;
                            border-left: 1px solid grey;
                            padding: 8px;
                            text-align: right;

                          "
                      >
                        Toplam:
                      </td>
                      <td
                        style="
                            font-weight: bold;
                            border-top: 1px solid grey;
                            text-align: left;
                            border-bottom: 1px solid grey;
                            border-right: 1px solid grey; padding: 8px;
                          "
                      >

                        {{
                          totalQuantity.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        }}kg
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <br />
            </table>

          

            <br />

            <!-- INVOICE FOOTER -->
          </vx-card>
          
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import VueBarcode from "vue-barcode";
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  name: "SiparisDetayButton",
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],

  data() {
    return {
      totalQuantity: 0.0,

      STOCKNAME: "",
      STOCKNO: "",
      barcodeValue: "",
      orderNumber: "",
      program: "",
      productDetail: [],
      receteListesi: [],

      shipFullAddress: "",
      shipFullName: "",
      shipCity: "",
      shipDistrict: "",

      quantityPrice: 0,
      grossAmount: 0,
      totalDiscount: 0,
      totalPrice: 0,

      invoiceFullAddress: "",
      invoiceFullName: "",
      telefon: 0,
      customerEmail: "",

      cargoProviderName: "",
      cargoTrackingNumber: "",
      discount: 0,

      mailTo: "",
      invoiceDistrict: "",
      invoiceCity: "",

      viewCheck: false,
      popupKartDetay: false,
      musteriId: "",
      imageSrc: "",
      serialNumber: ""
    };
  },
  created() {
    this.musteriId = Store.state.MusteriId;
  
    // this.imageSrc = "../../assets/images/logo/" + this.musteriId + ".png";
    //  console.log(this.imageSrc);
  },
  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe2");
    } /*
      findLogo() {
        return require("../../../../assets/images/logo/" +
          this.musteriId +
          ".png");
      },*/,
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    printInvoice() {
      window.print();
    },

    uretimDetayCek(item, secilenStok) {
      var vm = this;
      vm.$refs["modal-lotList"].show();

      this.STOCKNAME = secilenStok.STOCKNAME;
      this.STOCKNO = secilenStok.STOCKNO;
      this.receteListesi = item;
      this.receteListesi.forEach((val, index) => {
        this.totalQuantity += parseFloat(val.lotMiktar);
      });
      /*
        vm.productDetail = [];
        vm.totalPrice = 0;
        vm.quantityPrice = 0;
        console.log(productValue[0]);
  
        vm.cargoProviderName = productValue[0].cargoProviderName;
        vm.cargoTrackingNumber = productValue[0].cargoTrackingNumber.trim();
        vm.barcodeValue = vm.cargoTrackingNumber;
        vm.orderNumber = productValue[0].orderNumber;
        vm.program = productValue[0].program;
        vm.shipFullAddress = productValue[0].shipFullAddress;
        vm.shipFullName = productValue[0].shipFullName;
        vm.shipCity = productValue[0].shipCity;
        vm.shipDistrict = productValue[0].shipDistrict;
        vm.grossAmount = productValue[0].grossAmount;
        vm.totalDiscount = productValue[0].totalDiscount;
        //  vm.totalPrice = productValue[0].TOTAL;
        vm.invoiceFullAddress = productValue[0].invoiceFullAddress;
        vm.invoiceDistrict = productValue[0].invoiceDistrict;
        vm.invoiceCity = productValue[0].invoiceCity;
        vm.serialNumber = productValue[0].order_Id;
  
        if (productValue[0].program != "Trendyol") {
          vm.telefon = productValue[0].telefon;
          vm.customerEmail = productValue[0].customerEmail;
        } else {
          vm.telefon = "";
          vm.customerEmail = "";
        }
  
        vm.invoiceFullName = productValue[0].invoiceFullName;
        vm.discount = productValue[0].discount;
  
        vm.veriler = [];
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          program: productValue[0].program,
          orderNumber: productValue[0].orderNumber,
        };
        soap.createClient(url, function (err, client) {
          client.SiparisDetay(args, function (err, result) {
            if (result.SiparisDetayResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.SiparisDetayResult);
            console.log("SiparisDetay");
            console.log(vm.veriler);
  
            vm.veriler.forEach((value, i) => {
              vm.productDetail.push({
                barcode: value.barcode,
                productCode: value.productCode,
                merchantSku: value.merchantSku,
                productName: value.productName,
                quantity: value.quantity,
                price: value.price,
                amount: value.amount,
              });
              if (vm.productDetail[i].quantity > 1) {
                for (
                  let index = 0;
                  index < vm.productDetail[i].quantity;
                  index++
                ) {
                  vm.quantityPrice += vm.productDetail[i].price;
                }
              } else {
                vm.quantityPrice = vm.productDetail[i].price;
              }
              vm.totalPrice += value.price;
              //    console.log(value.price * value.quantity);
            });
          });
        });*/
    }
  },

  components: {
    "v-barcode": VueBarcode
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  }
  // mounted(){this.siparisDetay()}
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 850px;
}
.vs-table--tbody-table {
  min-width: 0px;
}
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
